import React from 'react';
import { LuSearch, LuFilter } from 'react-icons/lu';
import SafeIcon from '../../common/SafeIcon';

const INDUSTRIES = [
  'Agriculture',
  'Cloud Services',
  'Consulting',
  'Education',
  'Energy',
  'Finance',
  'Food & Beverage',
  'Healthcare',
  'Hospitality',
  'Legal',
  'Manufacturing',
  'Marketing',
  'Media & Entertainment',
  'Nonprofit',
  'Real Estate',
  'Retail',
  'Software',
  'Technology',
  'Telecommunications',
  'Transportation & Logistics',
  'Other'
];

const AccountFilters = ({ searchTerm, onSearchChange, industry, onIndustryChange }) => {
  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Search Input */}
        <div className="relative">
          <SafeIcon
            icon={LuSearch}
            className="absolute left-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-gray-400"
          />
          <input
            type="text"
            placeholder="Search accounts by name..."
            value={searchTerm}
            onChange={(e) => onSearchChange(e.target.value)}
            className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
          />
        </div>

        {/* Industry Filter */}
        <div className="relative">
          <SafeIcon
            icon={LuFilter}
            className="absolute left-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-gray-400"
          />
          <select
            value={industry}
            onChange={(e) => onIndustryChange(e.target.value)}
            className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all appearance-none bg-white"
          >
            <option value="">All Industries</option>
            {INDUSTRIES.map((ind) => (
              <option key={ind} value={ind}>
                {ind}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
};

export default AccountFilters;